import PropTypes from 'prop-types';
import { defaultBrickImageSrc } from '../../../../constants/imageUrls';
import commonCss from '../../../../styles/common.module.scss';
import ImageWithDefault from '../../../shared/ImageWithDefault';
import Default from '../../list/childPresentations/Default';
import WithGuideItemActions from '../../shared/WithGuideItemActions';
import css from './brickTile.module.scss';

const BrickTile = ({ guideItem, index }) => {
  return (
    <>
      <div
        data-testid={`brickTileOverlay guideItem-${index}`}
        data-testtype="brickTile"
        className={`${commonCss.overlay} ${css.container}`}
      >
        <WithGuideItemActions guideItem={guideItem}>
          <ImageWithDefault
            dataTestId="guideItemImage"
            src={guideItem?.image || defaultBrickImageSrc}
            alt={guideItem?.a11yTitle || guideItem?.title}
            className={css.image}
            placholderClassName={css.imagePlaceholder}
          />
        </WithGuideItemActions>
      </div>
      {guideItem?.isExtendedInfoEnabled && (
        <Default
          data-testid="extendedInfo"
          isExtendedInfoView
          guideItem={guideItem}
          index={0}
          className={css.container}
          containerClassName={css.guideItemContainer}
          imageWrapperClassName={css.guideItemImageWrapper}
        />
      )}
    </>
  );
};

BrickTile.propTypes = {
  guideItem: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default BrickTile;
